/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';

class PrintIframe extends Component {
  handleOnLoad = () => {
    const {
      loaded, name, onLoad,
    } = this.props;
    if (!loaded) {
      const pdfFrame = window.frames[name];
      pdfFrame.focus();
      pdfFrame.print();
      if (typeof onLoad === 'function') {
        onLoad();
      }
    }
  }

  render() {
    const {
      pdf, style, title,
    } = this.props;
    if (pdf) {
      const file = window.URL.createObjectURL(pdf);
      return (
        <iframe
          {...this.props}
          title={title}
          style={{ ...style, display: 'none' }}
          onLoad={this.handleOnLoad}
          src={file}
        />
      );
    }
    return null;
  }
}

PrintIframe.defaultProps = {
  id: 'pdf',
  onLoad: () => {},
  pdf: null,
  style: {},
  title: <Translate value="print" />,
};

PrintIframe.propTypes = {
  id: PropTypes.string,
  loaded: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  pdf: PropTypes.object,
  style: PropTypes.any,
  title: PropTypes.element,
};

export default PrintIframe;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/PrintIframe.jsx